import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  accent?: boolean;
}

export function Card({ children, className = '', accent = false, ...rest }: CardProps) {
  // accent prop agrega border-left coral (estilo "stat card" del mockup Aurora).
  const accentClass = accent ? 'border-l-4 border-l-distrito-500' : '';
  return (
    <div
      className={`bg-white rounded-xl shadow-sm border border-gray-200 ${accentClass} p-6 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '', ...rest }: CardProps) {
  return (
    <div className={`mb-4 ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className = '', ...rest }: CardProps) {
  return (
    <h2 className={`text-xl font-bold text-distrito-700 ${className}`} {...rest}>
      {children}
    </h2>
  );
}

export function CardBody({ children, className = '', ...rest }: CardProps) {
  return (
    <div className={`text-gray-700 ${className}`} {...rest}>
      {children}
    </div>
  );
}
